import(/* webpackMode: "eager" */ "/home/ubuntu/apps/icomm/v2_live/icomm/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ListProvider"] */ "/home/ubuntu/apps/icomm/v2_live/icomm/components/providers/list-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocketProvider"] */ "/home/ubuntu/apps/icomm/v2_live/icomm/components/providers/socket-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/ubuntu/apps/icomm/v2_live/icomm/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/apps/icomm/v2_live/icomm/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/apps/icomm/v2_live/icomm/node_modules/.pnpm/next@15.2.8_@babel+core@7.29.7_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
